import {TimeRule} from 'Event/attendee-rules/RuleConfig/RuleList/SingleRule/TimeRule'
import {isFuture, isPast} from 'lib/date-time'

export function matchesTimeRule(rule: TimeRule) {
  const isFromMatch = rule.from ? isPast(rule.from) : true
  const isToMatch = rule.to ? isFuture(rule.to) : true

  return isFromMatch && isToMatch
}
